$(function () {
  $('.mod_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    prevArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="//saikatei.net/cdn/shop/t/15/assets/img_slide_arrow_100x100.png?v=16713468532854331921792465851" class="slide-arrow next-arrow">',
    responsive: [{
      breakpoint: 599,  //ブレイクポイントを指定
      settings: {
        slidesToShow: 1,
        centerMode: true,
      }
    }]
  });
});